import React, { useCallback, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

/**
 * Hidden top-right region. Double-tap cycles through the three NAMA booth views:
 *   `/`  →  `/video`  →  `/showcase`  →  `/`
 */
const CYCLE = ['/', '/video', '/showcase'] as const

const DOUBLE_TAP_WINDOW_MS = 400

const getCurrentIndex = (pathname: string): number => {
	if (pathname.startsWith('/showcase')) return CYCLE.indexOf('/showcase')
	if (pathname.startsWith('/video')) return CYCLE.indexOf('/video')
	return CYCLE.indexOf('/')
}

const PageSwitcher = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const lastTapRef = useRef(0)

	const cycle = useCallback(() => {
		const current = getCurrentIndex(location.pathname)
		const next = CYCLE[(current + 1) % CYCLE.length]
		navigate(next)
	}, [location.pathname, navigate])

	const handleTouchEnd = useCallback(() => {
		const now = Date.now()
		if (now - lastTapRef.current < DOUBLE_TAP_WINDOW_MS) {
			cycle()
			lastTapRef.current = 0
		} else {
			lastTapRef.current = now
		}
	}, [cycle])

	return (
		<Region
			onDoubleClick={cycle}
			onTouchEnd={handleTouchEnd}
			aria-hidden
		/>
	)
}

const Region = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	width: 96px;
	height: 96px;
	z-index: 9999;
	background: transparent;
	cursor: pointer;
	-webkit-tap-highlight-color: transparent;
`

export default PageSwitcher
